import { axios } from '@Root/API'

export const editStudentCourseSession = payload => {
	return axios.put(`student-engagement/${payload.id}`, payload)
}
